<template>
  <div id="page_content" class="page">
    <div v-if="success">
      <el-carousel v-if="banner.length" :interval="1000000" arrow="never" :height="carouselHeight"
        @change="handleCarouselChange" :indicator-position="banner.length < 2 ? 'none' : ''">
        <el-carousel-item class="section" v-for="(item, index) in banner" :key="index"
          :style="{ backgroundColor: item.bg_color || '#f5d784' }">
          <div class="container">
            <div class="columns header is-vcentered is-hidden-mobile">
              <div class="column">
                <h1 class="title is-1 is-spaced">{{ item.title }}</h1>
                <p class="subtitle has-text-weight-medium">
                  {{ item.desc }}
                </p>
              </div>
              <div class="column">
                <!-- image -->
                <template v-if="item.banner_type == 1 && item.image">
                  <div class="image">
                    <img alt="..." :src="item.image" />
                  </div>
                </template>
                <!-- mp4 -->
                <template v-else-if="item.banner_type == 2">
                  <div class="image">
                    <video class="page_video" :ref="`video${index}`" controls autoplay loop muted>
                      <source :src="item.mp4_url" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </template>
                <template v-else-if="item.banner_type == 3">
                  <div class="image is-16by9">
                    <div class="iframe-wrap" v-html="item.video_url"></div>
                  </div>
                </template>
              </div>
            </div>
            <div class="columns header is-hidden-tablet">
              <div class="column">
                <h1 class="title is-1 is-spaced">{{ item.title }}</h1>
                <p class="subtitle has-text-weight-medium">
                  {{ item.desc }}
                </p>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <section class="cards section" v-if="items.length">
        <div class="container">
          <div class="columns is-variable is-6-desktop is-multiline">
            <template v-if="type == 1">
              <div class="is-hidden-mobile">
                <PageList :items="items" />
              </div>
              <div class="is-hidden-tablet">
                <PageCard :items="items" />
              </div>
            </template>
            <template v-if="type == 2">
              <PageCard :items="items" />
            </template>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { getPageContent } from "@/server/api.js";
import PageList from "@/components/Card/PageList.vue";
import PageCard from "@/components/Card/PageCard.vue";
import store from "@/store";

export default {
  components: {
    PageList,
    PageCard
  },
  data() {
    return {
      type: null, // 1 : list 2: card
      items: [],
      success: false,
      info: {},
      banner: [],
      carouselHeight: "",
      currentPlayingIndex: null,
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
    shopList() {
      return store.state.global.shopLists || [];
    },
  },
  mounted() {
    this.$nextTick(() => {
      // setTimeout(() => {
      //   var nav = document.getElementsByTagName('nav');
      //   var navheight = nav && nav[0].clientHeight;
      //   var footer = document.getElementById('footer-info')
      //   var footerheight = footer && footer.clientHeight;
      //   document.getElementById('page_content').style.minHeight = 'calc(100vh - ' + (navheight + footerheight - 22) + 'px)'
      // }, 1500)
      this.getInfo();
    });
  },
  methods: {
    goNext(item) {
      this.$router.push({
        path: item.path,
      });
    },
    handleCarouselChange(newIndex, oldIndex) {
      this.pauseAllVideos(oldIndex);
      this.currentPlayingIndex = newIndex;
      this.$nextTick(() => {
        this.playVideo(newIndex);
      });
    },
    pauseAllVideos(exceptIndex) {
      this.banner.forEach((video, index) => {
        if (index !== exceptIndex) {
          this.pauseVideo(index);
        }
      });
    },
    playVideo(index) {
      if (this.banner[index].banner_type == 2) {
        if (this.$refs[`video${index}`] && this.$refs[`video${index}`].length) {
          const video = this.$refs[`video${index}`][0];
          if (video) {
            video.play();
          }
        }
      }
    },
    pauseVideo(index) {
      if (this.banner[index].banner_type == 2) {
        if (this.$refs[`video${index}`] && this.$refs[`video${index}`].length) {
          const video = this.$refs[`video${index}`][0];
          if (video) {
            video.pause();
          }
        }
      }
    },
    handleVideoPlay(index) {
      if (index !== this.currentPlayingIndex) {
        this.pauseVideo(this.currentPlayingIndex);
        this.currentPlayingIndex = index;
      }
    },
    handleVideoPause(index) {
      if (index === this.currentPlayingIndex) {
        this.currentPlayingIndex = null;
      }
    },
    async getInfo() {
      try {
        // console.log(" this.$route.query.id==", this.$route.query)
        const { status, data } = await getPageContent({ page_id: this.$route.query.id });
        if (status == 0) {
          if (data && data.items && data.items.length) this.type = data.items[0].type
          this.items = data.items;

          this.banner = data.info;
          var screenWidth = window.innerWidth;
          if (screenWidth >= 769) {
            // 只有图文时高度设置为 420
            this.carouselHeight = '460px';
          } else {
            this.carouselHeight = "282px";
          }
          this.success = true;
        }
      } catch (error) { }
    }
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.page {
  min-height: 100%;
  margin-top: 52px;
}

.section {
  padding: 3rem 1.5rem;
}

.image {
  display: block;
  position: relative;
}

.is-16by9 {
  padding-top: 56.25%;
}

.image img {
  display: block;
  height: 100%;
}

@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
}

.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.columns:not(:last-child) {
  margin-bottom: 0rem;
}

.columns.is-vcentered {
  align-items: center;
}

@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}

.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}

.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title.is-1 {
  font-size: 3rem;
}

.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

.image.is-16by9 {
  padding-top: 56.25%;
}

.image {
  display: block;
  position: relative;
}

.section .image {
  display: block;
  position: relative;
  height: 340px;
}

.section .image img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.section .image .page_video {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}


@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
}

@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}

.columns:last-child {
  margin-bottom: -1.5rem;
}

.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}

@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}

.img {
  max-width: 648px !important;
}

.columns.is-multiline {
  flex-wrap: wrap;
}

@media screen and (min-width: 769px) {

  .column.is-6,
  .column.is-6-tablet {
    flex: none;
    width: 50%;
  }
}

.image {
  display: block;
  position: relative;
}

.image img {
  display: block;
  height: auto;
  width: 100%;
}

@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}

@media screen and (min-width: 769px) {
  .column.is-7,
  .column.is-7-tablet {
    flex: none;
    width: 58.33333337%;
  }

  .column.is-4,
  .column.is-4-tablet {
    flex: none;
    width: 33.33333337%;
  }

  .column.is-12,
  .column.is-12-tablet {
    flex: none;
    width: 100%;
  }

  .column.is-3,
  .column.is-3-tablet {
    flex: none;
    width: 25%;
  }

  .column.is-5,
  .column.is-5-tablet {
    flex: none;
    width: 41.66666674%;
  }
}
</style>
<style scoped>
/* 隐藏左箭头 */
.el-carousel__arrow--left {
  display: none;
}
</style>
<style scoped>
/* 隐藏左箭头 */
.el-carousel__arrow--left {
  display: none;
}

.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/page/index.vue